import { array_remove, Worker } from "../util";

export default class AresImportCtrl {

  constructor(KontaktService, $state){
    this.KontaktService = KontaktService;
    this.ics = [];
    this.icList = "";
    this.$state = $state;
    this.run = Worker(this._run);
  }

  add(){
    this.ics.push({ic:""});
  }

  remove(ic){
    array_remove(this.ics, ic);
  }

  addFromList(){
    this.icList
    .split(" ").join(",")
    .split("\n").join(",")
    .split(",")
    .map(ic => ic.trim())
    .map(ic => ({ic:ic}))
    .forEach(ic => this.ics.push(ic));      
    this.icList = "";
  }

  _run(){
    const ics = this.ics.map(ic => ic.ic);
    return this.KontaktService.importARES(ics).then(() => this.$state.go("kontakt-import"));
  }


}


// WEBPACK FOOTER //
// ./src/Kontakt/AresImportCtrl.js